import { createSelector } from 'reselect';

const getEmbeddedUrl = (state) => state.ndaPage.embeddedUrl;
const getEmbeddedUrlAttempting = (state) => state.ndaPage.attempting;
const getEmbeddedUrlError = (state) => state.ndaPage.errorCode;

export const getEmbeddedUrlSelector = createSelector(getEmbeddedUrl, (embeddedUrl) => embeddedUrl);
export const getEmbeddedUrlAttemptingSelector = createSelector(getEmbeddedUrlAttempting, (attempting) => attempting);
export const getEmbeddedUrlErrorSelector = createSelector(getEmbeddedUrlError, (errorCode) => errorCode);
